import { addInventory, deleteInventoryById, getAllInventory, getInventoryById, updateInventory } from "../../../helpers/backend_helper";
import { getInventoryByIdError, getInventoryByIdRequest, getInventoryByIdSuccess, inventoryEditSuccess, inventoryError, inventoryRequest, inventorySuccess } from "./reducer";

export const fetchInventory = (page:number,count:number,keyword:string) => async (dispatch: any) => {
    dispatch(inventoryRequest());
    try {
      const response: any = await getAllInventory(page,count,keyword);
      if (response && response.isSuccess) {
        dispatch(inventorySuccess(response.data));
        return response
      } else {
        dispatch(inventoryError("Failed to fetch Inventory"));
      }
    } catch (error: any) {
      dispatch(inventoryError(error.message));
    }
  };

  export const addNewInventory = (data: any) => async (dispatch: any) => {
      dispatch(inventoryRequest());
      try {
        
        const response: any = await addInventory(data);
        if (response && response.data) {
          dispatch(inventorySuccess(response.data));
          return response
        } else {
          dispatch(inventoryError("Failed to add Part Inventory"));
          return null
        }
        
      } catch (error: any) {
        dispatch(inventoryError(error.message));
        return null
      }
    };
    
    export const editInventory = (updatedData: any) => async (dispatch: any) => {
      dispatch(inventoryRequest());
      try {
        const response:any = await updateInventory(updatedData);
        if (response && response.isSuccess) {
          dispatch(inventoryEditSuccess(response.data));
          return response
        } else {
          dispatch(inventoryError("Failed to edit Part Inventory"));
          return null
        }
      } catch (error: any) {
        dispatch(inventoryError(error.message));
        return null
      }
    };

export const fetchInventoryById = (partInventoryId: string) => async (dispatch: any) => {
    dispatch(getInventoryByIdRequest());
    try {
      const response: any = await getInventoryById(partInventoryId);  
  
      if (response && response.isSuccess) {
        dispatch(getInventoryByIdSuccess(response.data)); 
        return response; 
      } else {
        dispatch(getInventoryByIdError("Failed to fetch Part Inventory by ID"));
        return null; 
      }
    } catch (error: any) {
      dispatch(getInventoryByIdError(error.message));  
      return null;
    }
  };    

  export const deleteInventory = (id: string) => async (dispatch: any) => {
    dispatch(inventoryRequest());
    try {
      const response: any = await deleteInventoryById(id);  
  
      if (response && response.isSuccess) {
        dispatch(inventorySuccess(response.data)); 
        return response; 
      } else {
        dispatch(inventoryError("Failed to fetch Part Inventory by ID"));
        return null; 
      }
    } catch (error: any) {
      dispatch(inventoryError(error.message));  
      return null;
    }
  }